import React, { useContext, useEffect, useState } from "react";
import { FaUser, FaGraduationCap, FaMapMarkerAlt, FaFileInvoice, FaTrash, FaEnvelope, FaCalendarAlt, FaPhone, FaCamera } from "react-icons/fa";
import axios from "axios";
import { getBaseUrl } from "../utils";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from "./UserContext";

const ProfileUpdate = () => {
    const { setUserProfile } = useContext(UserContext);

    const navigate = useNavigate(); // Place this inside your component

    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");
    const [dob, setDob] = useState("");
    const [activeTab, setActiveTab] = useState("profile");
    const [classList, setclassList] = useState([]);
    const [reasonList, setreasonList] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [profileData, setProfileData] = useState(null);
    const calculateAge = (dob) => {
        if (!dob) return "";
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();

        // Adjust age if the birthday hasn't happened this year yet
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
        ) {
            age--;
        }

        return age;
    };

    const menuItems = [
        { id: "profile", label: "My Profile", icon: <FaUser /> },
        { id: "education", label: "Educational Details", icon: <FaGraduationCap /> },
        { id: "address", label: "Address", icon: <FaMapMarkerAlt /> },
        { id: "billing", label: "My Billings", icon: <FaFileInvoice /> },
        { id: "delete", label: "Delete Account", icon: <FaTrash />, className: "text-red-500" },
    ];

    const [formData, setFormData] = useState({
        name: "",
        father_name: "",
        email: "",
        dob: "",
        gender: "",
        guardian_name: "",
        guardian_number: "",
        classId: "",
        category: "",
        qualification_completion_year: "",
        qualification_name: "",
        address: "",
        stateId: "",
        cityId: "",
        pincodeId: "",
        profile_img: null,
    });

    const [billingData, setBillingData] = useState([]);

    useEffect(() => {
        fetchBillingData();
    }, []);

    const fetchBillingData = async () => {
        try {

            const response = await axios.get(`${baseUrl}user_api/orderList`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data.status) {
                setBillingData(response.data.results);
            }
        } catch (error) {
            console.error("Error fetching billing data", error);
        }
    };

    const fetchLocationData = async (pincodeName) => {
        try {
            const response = await axios.get(`${baseUrl}user_api/locationList?pincodeName=${pincodeName}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.data.status && response.data.results.length > 0) {
                const location = response.data.results[0];
                setFormData((prevState) => ({
                    ...prevState,
                    state: location.stateInfo[0]?.name || "",
                    city: location.cityInfo[0]?.name || "",
                    stateId: location.stateInfo[0]?._id || "",
                    cityId: location.cityInfo[0]?._id || "",
                    pincodeId: location._id || "",
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    state: "",
                    city: "",
                    stateId: "",
                    cityId: "",
                    pincodeId: "",
                }));
                alert("No location data found for the provided pincode.");
            }
        } catch (error) {
            console.error("Error fetching location data:", error.message);
        }
    };

    async function classList_get() {
        try {
            const response = await axios.get(baseUrl + "user_api/classList", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data.status) {
                console.log("response----classList----->", response.data.results);
                setclassList(response.data.results);
            } else {
                console.log("Failed to fetch profile data.");
            }
        } catch (error) {
            console.log("Error fetching profile data: " + error.message);
        } finally {
            //setLoading(false);
        }
    }

    async function reason_get() {
        try {
            const response = await axios.get(baseUrl + "user_api/reason", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data.status) {
                console.log("response----classList----->", response.data.results);
                setreasonList(response.data.results);
            } else {
                console.log("Failed to fetch profile data.");
            }
        } catch (error) {
            console.log("Error fetching profile data: " + error.message);
        } finally {
            //setLoading(false);
        }
    }

    useEffect(() => {
        if (!token) {
            console.log("Token is missing. Please login again.");
            //setLoading(false);
            return;
        }
        classList_get();
        reason_get();
    }, [token]);


    useEffect(() => {
        if (!token) {
            setError("Token is missing. Please login again.");
            setLoading(false);
            return;
        }
        const fetchProfileData = async () => {
            try {
                const response = await axios.get(baseUrl + "user_api/getProfileData", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                console.log("response--------->", response.data.results);
                if (response.data.status) {
                    setProfileData(response.data.results);
                } else {
                    setError("Failed to fetch profile data.");
                }
            } catch (error) {
                setError("Error fetching profile data: " + error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchProfileData();
    }, [token]);



    const handleFormDataNEW = (input) => (e) => {
        let value = e.target?.value; // Use let instead of const

        console.log(input)
        // Restrict 'name' field to only letters and spaces
        if (input === "name") {
            value = value.replace(/[^A-Za-z\s]/g, ""); // Allow only letters and spaces
        }

        // Trigger pincode API call if the pincodeName is updated
        if (input === "pincodeName" && value.length === 6) {
            fetchLocationData(value);
        }

         if (input === "classId") {
    const selectedClass = classList.find(
        (c) => c._id === value
    );

    const education_type = selectedClass?.education_type || "";

    console.log("education_type", education_type);

    setFormData((prevState) => ({
        ...prevState,
        classId: value,
        qualification_name: education_type,
    }));

    return; // stop further execution
}
            

        // Calculate age if dob is updated
        if (input === "dob") {
            const newAge = calculateAge(value);
            setFormData((prevState) => ({
                ...prevState,
                [input]: value,
                age: newAge,
            }));
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [input]: value,
            }));
        }
    };

    // Determine if the user is under 18 based on dob
    const age = formData.dob ? calculateAge(formData.dob) : 0;
    const isUnder18 = age < 18;

    useEffect(() => {
        if (profileData) {
            setFormData((prevState) => ({
                ...prevState,
                profile_img: profileData.profile_img || "",
                name: profileData.name || "",
                father_name: profileData.father_name || "",
                email: profileData.email || "",
                dob: profileData.dob || "",
                gender: profileData.gender || "",
                guardian_name: profileData.guardian_name || "",
                guardian_number: profileData.guardian_number || "",
                classId: profileData.classId || "",
                category: profileData.category || "",
                qualification_completion_year: profileData.qualification_completion_year || "",
                qualification_name: profileData.qualification_name || "",
                address: profileData.address || "",
                state: profileData.stateDetails?.name || "",
                stateId: profileData.stateDetails?._id || "",
                city: profileData.cityDetails?.name || "",
                cityId: profileData.cityDetails?._id || "",
                pincodeName: profileData.pincodeDetails?.name || "",
                pincodeId: profileData.pincodeDetails?._id || "",

            }));
        }
    }, [profileData]);


    const FormOneSubmit = async (e) => {
        e.preventDefault();
        console.log("formData---FormOneSubmit->", formData);
        console.log("token---FormOneSubmit->", token);
        const formDataToSend = new FormData();
        if (formData.name) formDataToSend.append("name", formData.name);
        if (formData.father_name) formDataToSend.append("father_name", formData.father_name);
        if (formData.email) formDataToSend.append("email", formData.email);
        if (formData.dob) formDataToSend.append("dob", formData.dob);
        if (formData.gender) formDataToSend.append("gender", formData.gender);
        if (formData.guardian_name) formDataToSend.append("guardian_name", formData.guardian_name);
        if (formData.guardian_number) formDataToSend.append("guardian_number", formData.guardian_number);

        if (formData.classId) formDataToSend.append("classId", formData.classId);
        if (formData.category) formDataToSend.append("category", formData.category);
        if (formData.qualification_completion_year) formDataToSend.append("qualification_completion_year", formData.qualification_completion_year);
        if (formData.qualification_name) formDataToSend.append("qualification_name", formData.qualification_name);
        if (formData.address) formDataToSend.append("address", formData.address);
        if (formData.stateId) formDataToSend.append("stateId", formData.stateId);
        if (formData.cityId) formDataToSend.append("cityId", formData.cityId);
        if (formData.pincodeId) formDataToSend.append("pincodeId", formData.pincodeId);

        if (formData.profile_img) {
            formDataToSend.append("profile_img", formData.profile_img);
        } else {
            formDataToSend.append("profile_img", "");
        }
        try {
            console.log("formDataToSend--------------------->", formDataToSend);
            const response = await axios.patch(baseUrl + "user_api/profileUpdate", formDataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("API Response------------------------->:", response.data);
            toast.success(response.data.message);
            console.log("API Response------------------------->:", response.data.results);

            if (response.data.results) {
                setUserProfile({
                    name: response.data.results.name,
                    profile_img: response.data.results.profile_img, // or however your backend returns the image
                });
            }

            //window.location.reload();
        } catch (error) {
            toast.error("Error updating profile.");
            console.error("Error in API call:", error);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, profile_img: file }); // Set File, not URL
        }
        // if (file) {
        //     const imageUrl = URL.createObjectURL(file);
        //     setFormData({ ...formData, profile_img: imageUrl });
        // }
    };

    console.log("reasonList------>", reasonList);

    const delete_acc = async () => {

        try {
            // Find the selected radio button value
            const selectedReason = document.querySelector('input[name="deleteReason"]:checked');

            if (!selectedReason) {
                toast.error("Please select a reason for deleting your account.");
                return;
            }

            const isConfirmed = window.confirm("Are you sure you want to delete this account ?");
            if (!isConfirmed) return;

            const reason = selectedReason.nextSibling.textContent.trim(); // Get the reason text

            const response = await axios.post(
                baseUrl + "user_api/delete_acc",
                { reason }, // Sending reason in the request body
                {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Add your token here
                        'Content-Type': 'application/json', // Use JSON format
                    },
                }
            );

            console.log("Delete Account Response:", response.data);

            if (response.status === 200) {
                toast.success("Account deleted successfully!");
                setTimeout(() => {
                    navigate("/logout"); // Update with your logout route
                }, 2000);
                // Optionally, redirect to another page
            } else {
                toast.error(response.data.message || "Failed to delete account.");
            }
        } catch (error) {
            toast.error("Error deleting account.");
            console.error("Error in API call:", error);
        }
    };

    const getMaxDOB = () => {
        const maxYear = new Date().getFullYear() - 12;
        return `${maxYear}-12-31`; // ✅ Allow entire year
    };

    return (

        <div className="md:flex min-h-screen">
            <ToastContainer />
            {/* Sidebar Navigation */}
            <div className="md:w-1/4 w-full space-y-4 p-2 rounded-lg border">
                {menuItems.map(({ id, label, icon, className }) => (
                    <button
                        key={id}
                        className={`flex items-center p-2.5 w-full rounded-lg text-left transition ${activeTab === id
                            ? "bg-black text-white shadow-md font-semibold"
                            : "border border-white bg-white hover:bg-gray-200"
                            } ${className || ""}`}
                        onClick={() => setActiveTab(id)}
                    >
                        <span className="mr-3 text-lg">{icon}</span> {label}
                    </button>
                ))}
            </div>

            {/* Main Content */}
            <div className="md:w-3/4 w-full p-2 bg-gray rounded-xl border md:ml-6 mt-6 sm:mt-0">
                {activeTab === "profile" && (
                    <div>
                        <div className="flex flex-col items-start mb-6">
                            <h2 className="text-xl font-bold mb-4 text-left">My Profile</h2>
                            <div className="relative w-full rounded-full flex items-center justify-center overflow-hidden">
                                <div className="w-full flex items-center justify-center">
                                    <div className="relative">
                                        {/* Profile Image */}
                                        <div className="rounded-full w-[100px] h-[100px] overflow-hidden">
                                            {formData.profile_img ? (
                                                <img
                                                    src={
                                                        formData.profile_img instanceof File
                                                            ? URL.createObjectURL(formData.profile_img)
                                                            : formData.profile_img
                                                    }
                                                    alt="Profile Preview"
                                                    className="w-full h-full object-cover"
                                                />
                                            ) : (
                                                <FaUser className="text-4xl text-gray-600" />
                                            )}
                                        </div>
                                        {/* Camera Icon */}
                                        <div className="absolute bottom-0 right-0 bg-black bg-opacity-50 p-2 rounded-full cursor-pointer flex items-center justify-center">
                                            <label className="cursor-pointer">
                                                <FaCamera className="text-white text-sm" />
                                                <input
                                                    type="file"
                                                    className="hidden"
                                                    accept="image/*"
                                                    onChange={handleFileChange}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>



                        {/* Personal Details */}
                        <h3 className="text-md font-semibold mb-2">Edit your details</h3>
                        <div className="grid md:grid-cols-2 gap-4">
                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                <div>
                                    <img src="/assates/Full__Name.svg" alt="images" />
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <input
                                        type="text"
                                        name="name"
                                        required
                                        placeholder="Full Name"
                                        className="w-full pt-3 pb-3"
                                        style={{ outline: "none" }}
                                        value={formData.name}
                                        onChange={handleFormDataNEW("name")}
                                    />
                                </div>
                            </div>

                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                <div>
                                    <img src="/assates/father_name.svg" alt="images" />
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <input
                                        type="text"
                                        name="father_name"
                                        required
                                        placeholder="Father’s Name"
                                        className="w-full pt-3 pb-3"
                                        style={{ outline: "none" }}
                                        value={formData.father_name}
                                        onChange={handleFormDataNEW("father_name")}
                                    />
                                </div>
                            </div>


                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                <div>
                                    <img src="/assates/Mail.svg" alt="images" />
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <input
                                        type="email"
                                        name="email"
                                        required
                                        placeholder="Email ID"
                                        className="w-full pt-3 pb-3"
                                        style={{ outline: "none" }}
                                        value={formData.email}
                                        onChange={handleFormDataNEW("email")}
                                    />
                                </div>
                            </div>
                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                <div>
                                    <img src="/assates/Choose_gander.svg" alt="images" />
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <select
                                        name="gender"
                                        required
                                        className="w-full p-3"
                                        style={{ outline: "none" }}
                                        value={formData.gender}
                                        onChange={handleFormDataNEW("gender")}
                                    >
                                        <option value="" disabled>Choose Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </select>
                                </div>
                            </div>

                            <div className="flex justify-between gap-[20px]">
                                <div className="flex bg-[#FFFFFF] overflow-hidden w-full rounded-[10px] items-center">
                                    <div className="w-full ">
                                        <input
                                            type="date"
                                            name="dob"
                                            required
                                            placeholder="DD/MM/YYYY"
                                            className="w-full p-3"
                                            style={{ outline: "none" }}
                                            // value={dob}
                                            // onChange={(e) => setDob(e.target.value)}
                                            value={formData.dob}
                                            max={getMaxDOB()}
                                            onChange={handleFormDataNEW("dob")}
                                        />
                                    </div>
                                </div>
                                <div className="bg-[#FFFFFF] w-[100px] rounded-[15px] flex items-center justify-center">
                                    {age}
                                </div>
                            </div>

                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                <div>
                                    <img src="/assates/call.svg" alt="images" />
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <input
                                        type="text"
                                        name="number"
                                        required
                                        placeholder="+91 XXXX XX XXXX"
                                        className="w-full pt-3 pb-3"
                                        style={{ outline: "none" }}
                                        value={profileData ? profileData.number : ""}
                                        disabled
                                    />
                                </div>
                            </div>

                            
                        </div>
                        {isUnder18 && (
                            <div className="pt-6">

                                <h3 className="text-md font-semibold mb-2 pb-6">You’re under 18y, Please fill your Guardian’s Details:</h3>

                                <div className="flex justify-between gap-[20px]">
                                    <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                        <div>
                                            <img src="/assates/Full__Name.svg" alt="images" />
                                        </div>
                                        <div className="w-full pl-2 pr-2">
                                            <input
                                                type="text"
                                                name="guardian_name"
                                                required
                                                placeholder="Guardian’s Name"
                                                className="w-full pt-3 pb-3"
                                                style={{ outline: "none" }}
                                                value={formData.guardian_name}
                                                onChange={handleFormDataNEW("guardian_name")}
                                            />
                                        </div>
                                    </div>
                                    <div className="bg-[#FFFFFF] w-[150px] rounded-[15px] flex items-center justify-center">
                                        +91
                                    </div>

                                    <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                        <div>
                                            <img src="/assates/call.svg" alt="images" />
                                        </div>
                                        <div className="w-full pl-2 pr-2">
                                            <input
                                                type="number"
                                                name="guardian_number_New"
                                                required
                                                placeholder="XXXX XX XXXX"
                                                className="w-full pt-3 pb-3"
                                                style={{ outline: "none" }}
                                                value={formData.guardian_number}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value.length <= 10) {
                                                        handleFormDataNEW("guardian_number")(e);
                                                    }
                                                }}
                                            />



                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* Update Button */}
                        <button className="mt-6 w-1/2 bg-black text-white py-2 rounded ml-auto block" onClick={FormOneSubmit}  >Update</button>
                    </div>
                )}

                {activeTab === "education" && (
                    <div>
                        <h2 className="text-xl font-bold mb-4">Educational Details</h2>
                        <div className="grid grid-cols-2 gap-4">
                            <div className='w-full flex flex-col gap-[2px]'>
                                <label className='Header__text !text-[14px]'>Education Details</label>
                                <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                    <div>
                                        <img
                                            src="/assates/Eduction.svg"
                                            alt="images"
                                        />
                                    </div>
                                    <div className="w-full pl-2 pr-2">
                                        <select className="w-full pt-3 pb-3"
                                            style={{
                                                outline: "none",
                                            }}
                                            onChange={handleFormDataNEW("classId")}
                                            value={formData.classId}
                                        >
                                            {classList.map((classItem, index) => (
                                                <option key={index} value={classItem._id}>
                                                    {classItem.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className='w-full flex flex-col gap-[2px]'>
                                <label className='Header__text !text-[14px]'>Select Category</label>
                                <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                    <div>
                                        <img
                                            src="/assates/Eduction__catures.svg"
                                            alt="images"
                                        />
                                    </div>
                                    <div className="w-full pl-2 pr-2">
                                        <select className="w-full pt-3 pb-3"
                                            style={{
                                                outline: "none",
                                            }}
                                            onChange={handleFormDataNEW("category")}
                                            value={formData.category}
                                        >
                                            <option value="">Select Option</option>
                                            <option value="SC">SC</option>
                                            <option value="ST">ST</option>
                                            <option value="OBC">OBC</option>
                                            <option value="General">General</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex flex-col gap-[2px]'>
                                <label className='Header__text !text-[14px]'>Education/Degree Completion Year</label>
                                <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                    <div>
                                        <img
                                            src="/assates/Date__images.svg"
                                            alt="images"
                                        />
                                    </div>
                                    <div className="w-full pl-2 pr-2">
                                        {/* <input
                                        type="date"
                                        name=""
                                        required
                                        placeholder="Completion Year"
                                        className="w-full pt-3 pb-3"
                                        style={{
                                            outline: "none",
                                        }}
                                        onChange={handleFormDataNEW("qualification_completion_year")}
                                        value={formData.qualification_completion_year}
                                    //min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split("T")[0]}
                                    /> */}


                                        <select
                                            name="qualification_completion_year"
                                            required
                                            className="w-full py-3"
                                            style={{ outline: "none" }}
                                            onChange={(e) =>
                                                handleFormDataNEW("qualification_completion_year")({
                                                    target: { value: e.target.value },
                                                })
                                            }
                                            value={formData.qualification_completion_year || ""}
                                        >
                                            <option value="" disabled>
                                                Select Year
                                            </option>
                                            {Array.from({ length: 201 }, (_, i) => {
                                                const currentYear = new Date().getFullYear();
                                                const year = currentYear - 100 + i;
                                                return (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                );
                                            })}
                                        </select>

                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex flex-col gap-[2px]'>
                                <label className='Header__text !text-[14px]'>Education/Degree Type</label>

                                <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                    <div>
                                        <img
                                            src="/assates/Eduction__catures.svg"
                                            alt="images"
                                        />
                                    </div>
                                    <div className="w-full pl-2 pr-2">
                                        {/* <select className="w-full pt-3 pb-3"
                                            style={{
                                                outline: "none",
                                            }}
                                            onChange={handleFormDataNEW("qualification_name")}
                                            value={formData.qualification_name}
                                        >
                                            <option value="">Select Option</option>
                                            <option value="Matriculation">Matriculation </option>
                                            <option value="12 th">12 th</option>
                                            <option value="Graduation">Graduation </option>
                                        </select> */}

                                           <input
                                                        type="text"
                                                        name="qualification_name"
                                                        className="w-full py-3"
                                                        value={formData.qualification_name || ""}
                                                        readOnly
                                                    />

                                    </div>
                                </div>
                            </div>

                        </div>
                        <button className="mt-6 w-1/2 bg-black text-white py-2 rounded ml-auto block" onClick={FormOneSubmit}>Update</button>
                    </div>
                )}
                {activeTab === "address" && (
                    <div>
                        <h2 className="text-xl font-bold mb-4">Edit Your Address</h2>
                        <div className="flex justify-between gap-[20px]">
                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                <div>
                                    <i class="ri-user-location-fill"></i>
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <input
                                        type="text"
                                        name="address"
                                        required
                                        placeholder="#545, Rishi Nagar, 3rd Floor"
                                        className="w-full pt-3 pb-3"
                                        style={{
                                            outline: "none",
                                        }}
                                        onChange={handleFormDataNEW("address")}
                                        value={formData.address}
                                    />
                                </div>
                            </div>
                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                <div>
                                    <i class="ri-map-pin-range-fill"></i>
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <input
                                        type="number"
                                        name="pincodeName"
                                        required
                                        placeholder="110034"
                                        className="w-full pt-3 pb-3"
                                        onChange={handleFormDataNEW("pincodeName")}
                                        style={{
                                            outline: "none",
                                        }}
                                        value={formData.pincodeName}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-between gap-[20px] pt-6">
                            <div className="flex bg-[#FFFFFF] w-full pl-3 rounded-[10px] items-center">
                                <div>
                                    <img
                                        src="/assates/House.svg"
                                        alt="images"
                                    />
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <input
                                        type="text"
                                        name="State"
                                        required
                                        placeholder="State"
                                        className="w-full pt-3 pb-3"
                                        style={{
                                            outline: "none",
                                        }}
                                        value={formData.state}
                                    />
                                </div>
                            </div>
                            <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                <div>
                                    <img
                                        src="/assates/States.svg"
                                        alt="images"
                                    />
                                </div>
                                <div className="w-full pl-2 pr-2">
                                    <input
                                        type="text"
                                        name="City"
                                        required
                                        placeholder="City"
                                        className="w-full pt-3 pb-3"
                                        style={{
                                            outline: "none",
                                        }}
                                        value={formData.city}
                                    />
                                </div>
                            </div>
                        </div>
                        <button className="mt-6 w-1/2 bg-black text-white py-2 rounded ml-auto block" onClick={FormOneSubmit}>Update</button>
                    </div>
                )}
                {activeTab === "billing" && (
                    // <div>
                    //     <h2 className="text-xl font-bold mb-4">My Billings</h2>
                    //     <table className="w-full border-collapse border border-gray-300">
                    //         <thead>
                    //             <tr className="bg-gray-100">
                    //                 <th className="border p-2">S.No</th>
                    //                 <th className="border p-2">ID</th>
                    //                 <th className="border p-2">Date & Time</th>
                    //                 <th className="border p-2">Pay For</th>
                    //                 <th className="border p-2">Price</th>
                    //             </tr>
                    //         </thead>
                    //         <tbody>
                    //             {[1, 2, 3].map((num) => (
                    //                 <tr key={num} className="text-center">
                    //                     <td className="border p-2">{num}</td>
                    //                     <td className="border p-2">#451561</td>
                    //                     <td className="border p-2">03 Jan 2025 | 3:00 PM</td>
                    //                     <td className="border p-2">Consultancy</td>
                    //                     <td className="border p-2 text-green-600">$12.00</td>
                    //                 </tr>
                    //             ))}
                    //         </tbody>
                    //     </table>
                    // </div>


                    <div>
                        <h2 className="text-xl font-bold mb-4">My Billings</h2>
                        <div className="overflow-x-auto">
                            <table className="min-w-full border-collapse border border-gray-300">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="border p-2">S.No</th>
                                        <th className="border p-2">ID</th>
                                        <th className="border p-2">Date & Time</th>
                                        <th className="border p-2">Pay For</th>
                                        <th className="border p-2">Status</th>
                                        <th className="border p-2">Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {billingData.map((item, index) => (
                                        <tr key={item._id} className="text-center">
                                            <td className="border p-2">{index + 1}</td>
                                            <td className="border p-2">{item.order_id}</td>
                                            <td className="border p-2">{item.Created_date}</td>
                                            <td className="border p-2">
                                                {item.type === "TEST"
                                                    ? item.test?.name || "Test"
                                                    : item.type === "COUNSELLING"
                                                        ? "Consultancy"
                                                        : item.type}
                                            </td>
                                            <td className="border p-2">{item.status}</td>
                                            <td className="border p-2 text-green-600">₹{item.amount}.00</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>


                )}
                {activeTab === "delete" && (
                    <div>
                        <h2 className="text-xl font-bold text-red-500 mb-4">Delete Account</h2>
                        <p>Select a reason for deleting your account:</p>
                        <div className="space-y-2">
                            {reasonList.map((data, i) => (
                                <label key={i} className="flex items-center">
                                    <input type="radio" name="deleteReason" className="mr-2" />
                                    <span>{data.reason_text}</span>
                                </label>
                            ))}
                        </div>
                        <button className="mt-4 bg-red-600 text-white px-4 py-2 rounded" onClick={() => delete_acc()} >Delete Account</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProfileUpdate;